<template>
  <div>
    <div class="bg-white py-6">
      <!-- Replace with your content -->
      <div>
        <div class="md:flex md:items-center md:justify-between sm:px-6 md:px-8">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate">
              {{ $t("messages.dailyReport.dailyReport") }}
            </h2>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4"></div>
        </div>
      </div>
    </div>
    <!-- /End replace -->

    <nav class="bg-white border-b border-t border-gray-200 flex" aria-label="Breadcrumb">
      <ol class="w-full mx-auto px-4 flex space-x-4 sm:px-6 md:px-8">
        <li class="flex">
          <div class="flex items-center">
            <a href="javascript:void(0)" class="text-gray-400 hover:text-gray-500">
              <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
              <span class="sr-only">Home</span>
            </a>
          </div>
        </li>
        <li v-for="page in pages" :key="page.name" class="flex">
          <div class="flex items-center">
            <svg class="flex-shrink-0 w-6 h-full text-gray-200" viewBox="0 0 24 44" preserveAspectRatio="none"
              fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
            </svg>
            <router-link :to="page.href" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :aria-current="page.current ? 'page' : undefined">{{ page.name }}</router-link>
          </div>
        </li>
      </ol>
    </nav>

    <div class="">
      <div class="space-y-8 divide-y divide-gray-200 bg-white py-3 border-b text-center">
        <div class="flex items-center justify-center sm:justify-evenly xs:justify-evenly flex-wrap">
          <div class="md:ml-4">
            <Listbox as="div" v-model="selected">
              <div class="relative w-48">
                <ListboxButton
                  class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                  <span class="block truncate">{{ selected.label }}</span>
                  <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                  </span>
                </ListboxButton>

                <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                  leave-to-class="opacity-0">
                  <ListboxOptions
                    class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                    <ListboxOption as="template" v-for="month in months" :key="month.label" :value="month"
                      @click="search(month)">
                      <li :class="[
                        'hover:text-white hover:bg-indigo-600 text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9',
                      ]">
                        <span :class="[
                          selected.value == month.value
                            ? 'font-semibold'
                            : 'font-normal',
                          'block truncate text-left',
                        ]">
                          {{ month.label }}
                        </span>

                        <span v-if="selected.value == month.value" :class="[
                          'absolute inset-y-0 right-0 flex items-center pr-4 pl-5',
                        ]">
                          <CheckIcon class="h-5 w-5" aria-hidden="true" />
                        </span>
                      </li>
                    </ListboxOption>
                  </ListboxOptions>
                </transition>
              </div>
            </Listbox>
          </div>
          <div class="max-w-lg w-64 lg:max-w-xs">
            <label for="search" class="sr-only">Search</label>
            <div class="relative text-gray-600 focus-within:text-gray-600">
              <div class="pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center">
                {{ $t("messages.dailyReport.from") }}
                :
              </div>
              <input id="from" v-model="fromDate" maxlength="10" @change="searchRage($event)"
                class="block w-full bg-white py-2 pl-14 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                placeholder="From" type="date" name="from" />
            </div>
          </div>
          <div class="max-w-lg w-64 lg:max-w-xs">
            <label for="search" class="sr-only">Search</label>
            <div class="relative text-gray-600 focus-within:text-gray-600">
              <div class="pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center">
                {{ $t("messages.dailyReport.to") }}:
              </div>
              <input id="from" v-model="toDate" maxlength="10" @change="searchRage($event)"
                class="block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                placeholder="To" type="date" name="to" />
            </div>
          </div>

          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8">
            <button type="button" @click="exports()"
              class="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500">
              <font-awesome-icon class="mr-2" :icon="['far', 'file-export']" />
              {{ $t("messages.dailyReport.exportReport") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="px-8 py-6" v-show="!isLoaded">
      <div class="space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center">
        <font-awesome-icon class="text-gray-500" :icon="['fas', 'circle-notch']" transform="grow-6" spin />
      </div>
    </div>

    <div class="py-6" v-show="isLoaded">
      <div class="sm:px-6 md:px-8">
        <div class="bg-white shadow sm:rounded-md">
          <div class="shadow overflow-x-auto overflow-y-visible relative border-b border-gray-200 sm:rounded-lg">
            <table class="table min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" @click="doSort('date')"
                    class="m-auto text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      {{ $t("messages.dailyReport.date") }}
                    </div>
                  </th>

                  <th scope="col" @click="doSort('newUser')"
                    class="px-3 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      {{ $t("messages.dailyReport.newUser") }}
                      <Tooltips label="ลูกค้าที่สมัครใหม่ภายในวัน">
                        <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                      </Tooltips>
                    </div>
                  </th>
                  <th scope="col" @click="doSort('activeUser')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      {{ $t("messages.dailyReport.activeUser") }}
                      <Tooltips label="user ที่เติมเงิน หรือ เล่น">
                        <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                      </Tooltips>
                    </div>
                  </th>
                  <th scope="col" @click="doSort('loggedInUserCount')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer">
                    {{ $t("messages.dailyReport.loggedInUser") }}
                  </th>
                  <th scope="col" @click="doSort('deposit')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.dailyReport.deposit") }}
                  </th>
                  <th scope="col" @click="doSort('withdraw')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer">
                    {{ $t("messages.dailyReport.withdraw") }}
                  </th>
                  <th scope="col" @click="doSort('creditAdjustAmount')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      {{ $t("messages.dailyReport.profit") }}
                      <Tooltips label="Deposit - Withdraw">
                        <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                      </Tooltips>
                    </div>
                  </th>
                  <th scope="col" @click="doSort('creditAdjustAmount')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                    {{ $t("messages.dailyReport.adminTopup") }}
                  </th>
                  <th scope="col" @click="doSort('withdrawPlayer')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer">
                    {{ $t("messages.dailyReport.depositPlayer") }}
                  </th>

                  <th scope="col" @click="doSort('withdrawPlayer')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer">
                    {{ $t("messages.dailyReport.withdrawPlayer") }}
                  </th>
                  <th scope="col" @click="doSort('totalBet')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.dailyReport.totalBetRounds") }}
                  </th>
                  <th scope="col" @click="doSort('betAmount')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.dailyReport.betAmount") }}
                  </th>
                  <th scope="col"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    <!-- Affiliate Amount -->
                    <div class="flex flex-nowrap items-center">
                      {{ $t("messages.dailyReport.commission") }}
                      <Tooltips label="ยอดรวมค่า Commission">
                        <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                      </Tooltips>
                    </div>
                  </th>
                  <th scope="col"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    <!-- Affiliate Amount -->
                    <div class="flex flex-nowrap items-center">
                      {{ $t("messages.dailyReport.affiliate") }}
                      <Tooltips label="ยอดรวม Affiliate">
                        <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                      </Tooltips>
                    </div>
                  </th>
                  <!-- <th scope="col" @click="doSort('validBetAmount')" class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    Valid Bet Amount
                  </th> -->
                  <th scope="col" @click="doSort('winLoss')"
                    class="px-3 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      {{ $t("messages.dailyReport.winLoss") }}
                      <Tooltips label="(settle amount + game deposit amount) - (bet amount - game withdraw amount)">
                        <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                      </Tooltips>
                    </div>
                  </th>
                  <th scope="col" @click="doSort('winningPercentage')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      {{ $t("messages.dailyReport.winlossPercent") }}
                      <Tooltips label="WinLoss / Bet Amount">
                        <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                      </Tooltips>
                    </div>
                  </th>
                  <th scope="col"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      {{ $t("messages.dailyReport.loyaltyRedeemCount") }}
                      <Tooltips label="จำนวนครั้งที่ลูกค้าใช้ loyalty point">
                        <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                      </Tooltips>
                    </div>
                  </th>
                  <th scope="col"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      {{ $t("messages.dailyReport.loyaltyRedeemAmount") }}
                      <Tooltips label="มูลค่ารางวัลที่ใช้ loyalty point แลก">
                        <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                      </Tooltips>
                    </div>
                  </th>
                  <th scope="col"
                      class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.dailyReport.couponRedeemCount") }}
                  </th>
                  <th scope="col"
                      class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.dailyReport.couponRedeemAmount") }}
                  </th>
                  <th scope="col"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      Wallet Balance
                    </div>
                  </th>
                  <th scope="col"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      Hold Balance
                    </div>
                  </th>
                  <th scope="col"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      Wallet Users
                    </div>
                  </th>
                  <th scope="col"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      Raw Bet
                      <Tooltips label="ยอด Bet จริง (ไม่นับ ref_code4)">
                        <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                      </Tooltips>
                    </div>
                  </th>
                  <th scope="col"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      Raw Settle
                      <Tooltips label="ยอด Settle จริง (ไม่นับ ref_code4)">
                        <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                      </Tooltips>
                    </div>
                  </th>
                  <th scope="col"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      Cancel Amount
                      <Tooltips label="ยอดยกเลิก (ไม่นับ ref_code4)">
                        <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                      </Tooltips>
                    </div>
                  </th>
                  <th scope="col"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    <div class="flex flex-nowrap items-center">
                      Cancel Count
                      <Tooltips label="จำนวนครั้งที่ยกเลิก (ไม่นับ ref_code4)">
                        <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                      </Tooltips>
                    </div>
                  </th>
                  <th scope="col"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    Withdraw Fee
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="data in dataRows" :key="data.id" class="hover:bg-gray-50">
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500" style="color: #4169e1">
                    {{ dayjs(data.date).format("LL") }}
                  </td>

                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      Number(data.newUser).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      Number(data.activeUser).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      Number(data.loggedInUserCount).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      parseFloat(data.deposit / 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>

                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      parseFloat(data.withdraw / 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right" :class="data.deposit / 100 + data.withdraw / 100 < 0
                      ? 'text-red-500'
                      : 'text-green-500'
                    ">
                    {{
                      parseFloat(
                        data.deposit / 100 + data.withdraw / 100
                      ).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>

                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      parseFloat(data.creditAdjustAmount / 100).toLocaleString(
                        "en",
                        {
                          useGrouping: true,
                          minimumFractionDigits: 2,
                        }
                      )
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      Number(data.depositPlayer).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      Number(data.withdrawPlayer).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      Number(data.totalBet).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      parseFloat(data.betAmount / 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      (Number(data.commissionAmount) / 100).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      (Number(data.downlineAmount) / 100).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <!-- <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ parseFloat(data.validBetAmount / 100).toLocaleString('en', { useGrouping:true, minimumFractionDigits: 2 }) }}
                  </td> -->
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    <p :class="winLoss = Number(data.winLoss) /
                        100 <
                        0
                        ? 'text-red-500'
                        : 'text-green-500'
                      ">
                      {{
                        (
                          Number(data.winLoss) /
                          100
                        ).toLocaleString("en", {
                          useGrouping: true,
                          minimumFractionDigits: 2,
                        })
                      }}
                    </p>
                  </td>

                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right" style="color: red" v-if="
                    (winningPercentage = parseFloat(data.winningPercentage)) <
                    0
                  ">
                    {{
                      (winningPercentage * 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 4,
                      })
                    }}%
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right" style="color: green" v-else>
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      Number(data.loyalty_redeem_count).toLocaleString(
                        "en",
                        {
                          useGrouping: true,
                          minimumFractionDigits: 0,
                        }
                      ) || "-"
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      Number(data.loyalty_redeem_amount / 100).toLocaleString(
                        "en",
                        {
                          useGrouping: true,
                          minimumFractionDigits: 2,
                        }
                      ) || "-"
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      data.coupon_redeem_count != null
                          ? Number(data.coupon_redeem_count).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 })
                          : "0"
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      data.coupon_redeem_amount != null
                          ? Number(data.coupon_redeem_amount / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 })
                          : "0.00"
                    }}
                  </td>
                  <td>
                    <div class="px-3 py-4 flex whitespace-nowrap text-sm text-gray-500 text-right justify-between gap-1">
                      <div></div>
                      <div>
                        {{
                          data.sum_balance != null
                              ? Number(data.sum_balance / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 })
                              : "-"
                        }}
                      </div>
                      <div>
                        <Tooltips v-if="data.as_of_date!==null" :label="`ยอดเงินรวมใน Wallet ณ เวลา ${data.as_of_date ? dayjs(data.as_of_date).format('HH:mm') : '-'}`">
                          <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                        </Tooltips>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="px-3 py-4 flex whitespace-nowrap text-sm text-gray-500 text-right justify-between gap-1">
                      <div></div>
                      <div>
                        {{
                          data.sum_hold_balance != null
                              ? Number(data.sum_hold_balance / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 })
                              : "-"
                        }}
                      </div>
                      <div>
                        <Tooltips v-if="data.as_of_date!==null" :label="`ยอดเงิน Hold รวมใน Wallet ณ เวลา ${data.as_of_date ? dayjs(data.as_of_date).format('HH:mm') : '-'}`">
                          <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                        </Tooltips>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="px-3 py-4 flex whitespace-nowrap text-sm  text-gray-500 text-right justify-between gap-1">
                      <div></div>
                      <div>
                        {{
                          data.user_count != null
                              ? Number(data.user_count).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 0 })
                              : "-"
                        }}
                      </div>
                      <div>
                        <Tooltips v-if="data.as_of_date!==null" :label="`จำนวน User ใน Wallet ณ เวลา ${data.as_of_date ? dayjs(data.as_of_date).format('HH:mm') : '-'}`">
                          <InformationCircleIcon class="h-5 w-5" aria-hidden="true"></InformationCircleIcon>
                        </Tooltips>
                      </div>
                    </div>
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      data.raw_bet != null
                          ? Number(data.raw_bet / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 })
                          : "-"
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      data.raw_settle != null
                          ? Number(data.raw_settle / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 })
                          : "-"
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      data.cancel_amount != null
                          ? Number(data.cancel_amount / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 })
                          : "-"
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      data.cancel_count != null
                          ? Number(data.cancel_count).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 0 })
                          : "-"
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      data.withdraw_fee_amount != null
                          ? Number(data.withdraw_fee_amount / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 })
                          : "-"
                    }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="bg-gray-50">
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ $t("messages.dailyReport.total") }}
                  </td>

                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      Number(totals.newUser).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>

                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      Number(totals.activeUser).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>

                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      Number(totals.loggedInUserCount).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>

                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      parseFloat(totals.deposit / 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      parseFloat(totals.withdraw / 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      parseFloat(
                        totals.deposit / 100 + totals.withdraw / 100
                      ).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      parseFloat(
                        totals.creditAdjustAmount / 100
                      ).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      Number(totals.depositPlayer).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      Number(totals.withdrawPlayer).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      Number(totals.totalBet).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      parseFloat(totals.betAmount / 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      (Number(totals.commissionAmount) / 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      (Number(totals.downlineAmount) / 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <!-- <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">{{ parseFloat(totals.validBetAmount / 100).toLocaleString('en', { useGrouping:true, minimumFractionDigits: 2 }) }}</td> -->
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      (
                        Number(totals.winLoss) /
                        100
                      ).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>

                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      Number(totals.loyalty_redeem_count).toLocaleString(
                        "en",
                        {
                          useGrouping: true,
                          minimumFractionDigits: 0,
                        }
                      ) || "-"
                    }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      Number(totals.loyalty_redeem_amount / 100).toLocaleString(
                        "en",
                        {
                          useGrouping: true,
                          minimumFractionDigits: 2,
                        }
                      ) || "-"
                    }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      totals.coupon_redeem_count != null
                          ? Number(totals.coupon_redeem_count).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 })
                          : "0"
                    }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                        totals.coupon_redeem_amount != null
                            ? Number(totals.coupon_redeem_amount/100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 })
                            : "0.00"
                    }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right"></td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right"></td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right"></td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ Number(totals.raw_bet / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 }) }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ Number(totals.raw_settle / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 }) }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ Number(totals.cancel_amount / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 }) }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ Number(totals.cancel_count).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 0 }) }}
                  </td>
                  <td class="px-3 font-medium py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ totals.withdraw_fee_amount != null ? Number(totals.withdraw_fee_amount / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 }) : "-" }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
  InformationCircleIcon
} from "@heroicons/vue/solid";
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import { inject, onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";
import Tooltips from "@/components/tools/Tooltips.vue";

dayjs.extend(localizedFormat);

const pages = [{ name: "Daily Report", href: "", current: true }];

export default {
  components: {
    Tooltips,
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    SelectorIcon,
    InformationCircleIcon
  },
  setup() {
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const toDate = ref("");
    const fromDate = ref("");
    let totals = ref({
      newUser: 0,
      activeUser: 0,
      loggedInUserCount: 0,
      deposit: 0,
      totalBet: 0,
      betAmount: 0,
      validBetAmount: 0,
      bonus: 0,
      winLoss: 0,
      winningPercentage: 0,
      withdraw: 0,
      depositPlayer: 0,
      withdrawPlayer: 0,
      commissionAmount: 0,
      downlineAmount: 0,
      creditAdjustAmount: 0,
      loyalty_redeem_amount: 0,
      loyalty_redeem_count: 0,
      coupon_redeem_amount: 0,
      coupon_redeem_count: 0,
      sum_balance: 0,
      sum_hold_balance: 0,
      user_count: 0,
      raw_bet: 0,
      raw_settle: 0,
      cancel_amount: 0,
      cancel_count: 0,
      withdraw_fee_amount: 0,
    });
    let sortBy = ref([]);

    const startDate = dayjs();
    const diff = startDate.diff("2021-07-01", "months");
    let months = ref([]);
    for (let i = 0; i <= diff; i++) {
      months.value.push({
        label: dayjs("2021-07-01").add(i, "month").format("MM/YYYY"),
        value: dayjs("2021-07-01").add(i, "month").format(),
      });
    }

    months.value.sort((a, b) => (dayjs(b.value).isAfter(dayjs(a.value)) ? 1 : -1));

    const yesterday = {
      label: "Yesterday",
      value: dayjs().add(-1, "day").format(),
    };
    months.value.unshift(yesterday);
    const selected = ref(months.value[0]);

    let dataRows = ref([]);
    let dataCount = ref(0);
    let isLoaded = ref(false);

    onMounted(() => {
      refetch();
    });

    const refetch = () => {
      let fromParams = dayjs(selected.value.value).startOf("month").format();
      let toParams = dayjs(selected.value.value).endOf("month").format();

      if (selected.value.label == "Yesterday") {
        fromParams = dayjs(selected.value.value)
          .hour(0)
          .minute(0)
          .second(0)
          .format();
        toParams = dayjs(selected.value.value)
          .hour(23)
          .minute(59)
          .second(59)
          .format();
      }

      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/report/daily-summary-op",
          null,
          {
            params: {
              operatorId: store.state.selectedOperator.operatorId,
              from: fromParams,
              to: toParams,
            },
          }
        )
        .then(({ data }) => {
          dataRows.value = (selected.value.label === 'Yesterday')? data.result:(getDaysInRange(fromParams, toParams)).map((date)=> {
            const findData = data.result.find(d => dayjs(d.date).hour(0).minute(0).second(0).format() === date.format())
            if(findData) {
              console.log(findData)
              return findData
            }
            return {
              "date": date,
              "operatorId": store.state.selectedOperator.operatorId,
              "newUser": 0,
              "activeUser": 0,
              "totalBet": "0",
              "gameWithdrawAmount": "0",
              "gameDepositAmount": "0",
              "deposit": "0",
              "depositPlayer": 0,
              "withdraw": "0",
              "withdrawPlayer": 0,
              "bonus": "0",
              "betAmount": "0",
              "validBetAmount": "0",
              "settleBetAmount": "0",
              "winCount": 0,
              "lossCount": 0,
              "drawCount": 0,
              "winLoss": "0",
              "winLossCountRatio": 0,
              "winningPercentage": 0,
              "creditAdjustAmount": "0",
              "auditTrail": 0,
              "downlineCount": 0,
              "downlineAmount": "0",
              "commissionCount": 0,
              "commissionAmount": "0",
              "rollbackDepositAmount": "0",
              "rollbackDepositCount": 0,
              "rollbackWithdrawAmount": "0",
              "rollbackWithdrawCount": 0,
              "group_settle_bet_amount": "0",
              "settle_count": 0,
              "loyalty_redeem_amount": "0",
              "loyalty_redeem_count": "0",
              "loggedInUserCount": 0,
              "sum_balance": null,
              "sum_hold_balance": null,
              "user_count": null,
              "as_of_date": null,
              "raw_bet": null,
              "raw_settle": null,
              "cancel_amount": null,
              "cancel_count": null,
              "withdraw_fee_amount": null
            }
          })
          dataCount.value = 0;
          isLoaded.value = true;

          totals.value = dataRows.value.reduce((a, b, _, { length }) => {
            return {
              newUser: Number(a.newUser) + Number(b.newUser),
              activeUser: Number(a.activeUser) + Number(b.activeUser),
              loggedInUserCount: Number(a.loggedInUserCount) + Number(b.loggedInUserCount),
              deposit: Number(a.deposit) + Number(b.deposit),
              totalBet: Number(a.totalBet) + Number(b.totalBet),
              betAmount: Number(a.betAmount) + Number(b.betAmount),
              validBetAmount:
                Number(a.validBetAmount) + Number(b.validBetAmount),
              bonus: Number(a.bonus) + Number(b.bonus),
              winLoss: Number(a.winLoss) + Number(b.winLoss),
              winningPercentage:
                Number(a.winningPercentage) +
                Number(b.winningPercentage) / length,
              withdraw: Number(a.withdraw) + Number(b.withdraw),
              depositPlayer: Number(a.depositPlayer) + Number(b.depositPlayer),
              rollbackWithdrawAmount: Number(a.rollbackWithdrawAmount) + Number(b.rollbackWithdrawAmount),
              rollbackDepositAmount: Number(a.rollbackDepositAmount) + Number(b.rollbackDepositAmount),
              withdrawPlayer:
                Number(a.withdrawPlayer) + Number(b.withdrawPlayer),
              commissionAmount: b.commissionAmount
                ? Number(a.commissionAmount) + Number(b.commissionAmount)
                : Number(a.commissionAmount),
              downlineAmount: b.downlineAmount
                ? Number(a.downlineAmount) + Number(b.downlineAmount)
                : Number(a.downlineAmount),
              creditAdjustAmount: Number(b.creditAdjustAmount)
                ? Number(a.creditAdjustAmount) + Number(b.creditAdjustAmount)
                : Number(a.creditAdjustAmount),
              loyalty_redeem_amount: b.loyalty_redeem_amount
                ? Number(a.loyalty_redeem_amount) +
                Number(b.loyalty_redeem_amount)
                : Number(a.loyalty_redeem_amount),
              loyalty_redeem_count: b.loyalty_redeem_count
                ? Number(a.loyalty_redeem_count) +
                Number(b.loyalty_redeem_count)
                : Number(a.loyalty_redeem_count),
              coupon_redeem_amount: b.coupon_redeem_amount
                  ? Number(a.coupon_redeem_amount) +
                  Number(b.coupon_redeem_amount)
                  : Number(a.loyalty_redeem_amount),
              coupon_redeem_count: b.coupon_redeem_count
                  ? Number(a.coupon_redeem_count) +
                  Number(b.coupon_redeem_count)
                  : Number(a.coupon_redeem_count),
              raw_bet: b.raw_bet != null ? Number(a.raw_bet) + Number(b.raw_bet) : Number(a.raw_bet),
              raw_settle: b.raw_settle != null ? Number(a.raw_settle) + Number(b.raw_settle) : Number(a.raw_settle),
              cancel_amount: b.cancel_amount != null ? Number(a.cancel_amount) + Number(b.cancel_amount) : Number(a.cancel_amount),
              cancel_count: b.cancel_count != null ? Number(a.cancel_count) + Number(b.cancel_count) : Number(a.cancel_count),
              withdraw_fee_amount: b.withdraw_fee_amount != null ? Number(a.withdraw_fee_amount) + Number(b.withdraw_fee_amount) : Number(a.withdraw_fee_amount),
            };
          });
        })
        .catch(({ response }) => {
          console.log(response.data);
        });
    };

    const getDaysInRange = (startDate, endDate)  => {
      const dates = [];
      let current = dayjs(startDate).startOf('day');
      const end = dayjs(endDate).startOf('day');

      while (current.isBefore(end) || current.isSame(end, 'day')) {
        dates.push(current);
        current = current.add(1, 'day');
      }

      return dates;
    }

    const search = (option) => {
      let fromParams = dayjs(option.value).startOf("month").format();
      let toParams = dayjs(option.value).endOf("month").format();
      if (option.label == "Yesterday") {
        fromParams = dayjs(option.value).hour(0).minute(0).second(0).format();
        toParams = dayjs(option.value).hour(23).minute(59).second(59).format();
      }

      isLoaded.value = false;
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/report/daily-summary-op",
          null,
          {
            params: {
              operatorId: store.state.selectedOperator.operatorId,
              from: fromParams,
              to: toParams,
            },
          }
        )
        .then(({ data }) => {
          dataRows.value = (option.label == "Yesterday")? data.result:(getDaysInRange(fromParams, toParams)).map((date)=> {
            const findData = data.result.find(d => dayjs(d.date).hour(0).minute(0).second(0).format() === date.format())
            if(findData) {
              return findData
            }
            return {
              "date": date,
              "operatorId": store.state.selectedOperator.operatorId,
              "newUser": 0,
              "activeUser": 0,
              "totalBet": "0",
              "gameWithdrawAmount": "0",
              "gameDepositAmount": "0",
              "deposit": "0",
              "depositPlayer": 0,
              "withdraw": "0",
              "withdrawPlayer": 0,
              "bonus": "0",
              "betAmount": "0",
              "validBetAmount": "0",
              "settleBetAmount": "0",
              "winCount": 0,
              "lossCount": 0,
              "drawCount": 0,
              "winLoss": "0",
              "winLossCountRatio": 0,
              "winningPercentage": 0,
              "creditAdjustAmount": "0",
              "auditTrail": 0,
              "downlineCount": 0,
              "downlineAmount": "0",
              "commissionCount": 0,
              "commissionAmount": "0",
              "rollbackDepositAmount": "0",
              "rollbackDepositCount": 0,
              "rollbackWithdrawAmount": "0",
              "rollbackWithdrawCount": 0,
              "group_settle_bet_amount": "0",
              "settle_count": 0,
              "loyalty_redeem_amount": "0",
              "loyalty_redeem_count": "0",
              "loggedInUserCount": 0,
              "raw_bet": null,
              "raw_settle": null,
              "cancel_amount": null,
              "cancel_count": null,
              "withdraw_fee_amount": null,
              "sum_balance": null,
              "sum_hold_balance": null,
              "user_count": null,
              "as_of_date": null
            }
          })
          dataCount.value = 0;
          isLoaded.value = true;

          totals.value = dataRows.value.reduce((a, b, _, { length }) => {
            return {
              newUser: Number(a.newUser) + Number(b.newUser),
              activeUser: Number(a.activeUser) + Number(b.activeUser),
              loggedInUserCount: Number(a.loggedInUserCount) + Number(b.loggedInUserCount),
              deposit: Number(a.deposit) + Number(b.deposit),
              totalBet: Number(a.totalBet) + Number(b.totalBet),
              betAmount: Number(a.betAmount) + Number(b.betAmount),
              validBetAmount:
                Number(a.validBetAmount) + Number(b.validBetAmount),
              bonus: Number(a.bonus) + Number(b.bonus),
              winLoss: Number(a.winLoss) + Number(b.winLoss),
              winningPercentage:
                Number(a.winningPercentage) +
                Number(b.winningPercentage) / length,
              withdraw: Number(a.withdraw) + Number(b.withdraw),
              depositPlayer: Number(a.depositPlayer) + Number(b.depositPlayer),
              withdrawPlayer:
                Number(a.withdrawPlayer) + Number(b.withdrawPlayer),
              commissionAmount: b.commissionAmount
                ? Number(a.commissionAmount) + Number(b.commissionAmount)
                : Number(a.commissionAmount),
              downlineAmount: b.downlineAmount
                ? Number(a.downlineAmount) + Number(b.downlineAmount)
                : Number(a.downlineAmount),
              creditAdjustAmount: Number(b.creditAdjustAmount)
                ? Number(a.creditAdjustAmount) + Number(b.creditAdjustAmount)
                : Number(a.creditAdjustAmount),
              loyalty_redeem_amount: b.loyalty_redeem_amount
                ? Number(a.loyalty_redeem_amount) +
                Number(b.loyalty_redeem_amount)
                : Number(a.loyalty_redeem_amount),
              loyalty_redeem_count: b.loyalty_redeem_count
                ? Number(a.loyalty_redeem_count) +
                Number(b.loyalty_redeem_count)
                : Number(a.loyalty_redeem_count),
              raw_bet: b.raw_bet != null ? Number(a.raw_bet) + Number(b.raw_bet) : Number(a.raw_bet),
              raw_settle: b.raw_settle != null ? Number(a.raw_settle) + Number(b.raw_settle) : Number(a.raw_settle),
              cancel_amount: b.cancel_amount != null ? Number(a.cancel_amount) + Number(b.cancel_amount) : Number(a.cancel_amount),
              cancel_count: b.cancel_count != null ? Number(a.cancel_count) + Number(b.cancel_count) : Number(a.cancel_count),
              withdraw_fee_amount: b.withdraw_fee_amount != null ? Number(a.withdraw_fee_amount) + Number(b.withdraw_fee_amount) : Number(a.withdraw_fee_amount),
            };
          });
        })
        .catch((err) => {
          console.log(err);
          isLoaded.value = true;
        });
    };

    const prev = () => {
      if (route.query.page && route.query.page !== "1") {
        router
          .push({
            query: {
              page: parseInt(route.query.page) - 1,
            },
          })
          .then(() => {
            refetch();
          });
      }
    };

    const next = () => {
      router
        .push({
          query: {
            page: parseInt(route.query.page) + 1 || 2,
          },
        })
        .then(() => {
          refetch();
        });
    };

    const viewData = (data) => {
      router.push({ name: "Wallet Info", params: { id: data.id } });
    };

    const searchRage = (e) => {
      let from = dayjs(fromDate.value).hour(0).minute(0).second(0);
      let to = dayjs(toDate.value).hour(23).minute(59).second(59);
      if (
        (e.code == "Enter" ||
          e.code == "NumpadEnter" ||
          e.type == "change" ||
          e.keyCode == 13) &&
        from.isValid() &&
        to.isValid() &&
        from.isBefore(to)
      ) {
        isLoaded.value = false;
        axios
          .post(
            process.env.VUE_APP_API_ENDPOINT +
            "/admin/api/v1/report/daily-summary-op",
            null,
            {
              params: {
                operatorId: store.state.selectedOperator.operatorId,
                from: from.format(),
                to: to.format(),
              },
            }
          )
          .then(({ data }) => {
            dataRows.value = (selected.value.label === 'Yesterday')? data.result:(getDaysInRange(from, to)).map((date)=> {
              const findData = data.result.find(d => dayjs(d.date).hour(0).minute(0).second(0).format() === date.format())
              if(findData) {
                return findData
              }
              return {
                "date": date,
                "operatorId": store.state.selectedOperator.operatorId,
                "newUser": 0,
                "activeUser": 0,
                "totalBet": "0",
                "gameWithdrawAmount": "0",
                "gameDepositAmount": "0",
                "deposit": "0",
                "depositPlayer": 0,
                "withdraw": "0",
                "withdrawPlayer": 0,
                "bonus": "0",
                "betAmount": "0",
                "validBetAmount": "0",
                "settleBetAmount": "0",
                "winCount": 0,
                "lossCount": 0,
                "drawCount": 0,
                "winLoss": "0",
                "winLossCountRatio": 0,
                "winningPercentage": 0,
                "creditAdjustAmount": "0",
                "auditTrail": 0,
                "downlineCount": 0,
                "downlineAmount": "0",
                "commissionCount": 0,
                "commissionAmount": "0",
                "rollbackDepositAmount": "0",
                "rollbackDepositCount": 0,
                "rollbackWithdrawAmount": "0",
                "rollbackWithdrawCount": 0,
                "group_settle_bet_amount": "0",
                "settle_count": 0,
                "loyalty_redeem_amount": "0",
                "loyalty_redeem_count": "0",
                "loggedInUserCount": 0,
                "raw_bet": null,
                "raw_settle": null,
                "cancel_amount": null,
                "cancel_count": null,
                "withdraw_fee_amount": null
              }
            })
            dataCount.value = 0;
            isLoaded.value = true;

            totals.value = dataRows.value.reduce((a, b, _, { length }) => {
              return {
                newUser: Number(a.newUser) + Number(b.newUser),
                activeUser: Number(a.activeUser) + Number(b.activeUser),
                loggedInUserCount: Number(a.loggedInUserCount) + Number(b.loggedInUserCount),
                deposit: Number(a.deposit) + Number(b.deposit),
                totalBet: Number(a.totalBet) + Number(b.totalBet),
                betAmount: Number(a.betAmount) + Number(b.betAmount),
                validBetAmount:
                  Number(a.validBetAmount) + Number(b.validBetAmount),
                bonus: Number(a.bonus) + Number(b.bonus),
                winLoss: Number(a.winLoss) + Number(b.winLoss),
                winningPercentage:
                  Number(a.winningPercentage) +
                  Number(b.winningPercentage) / length,
                withdraw: Number(a.withdraw) + Number(b.withdraw),
                depositPlayer:
                  Number(a.depositPlayer) + Number(b.depositPlayer),
                withdrawPlayer:
                  Number(a.withdrawPlayer) + Number(b.withdrawPlayer),
                commissionAmount: b.commissionAmount
                  ? Number(a.commissionAmount) + Number(b.commissionAmount)
                  : Number(a.commissionAmount),
                downlineAmount: b.downlineAmount
                  ? Number(a.downlineAmount) + Number(b.downlineAmount)
                  : Number(a.downlineAmount),
                creditAdjustAmount: Number(b.creditAdjustAmount)
                  ? Number(a.creditAdjustAmount) + Number(b.creditAdjustAmount)
                  : Number(a.creditAdjustAmount),
                loyalty_redeem_amount: b.loyalty_redeem_amount
                  ? Number(a.loyalty_redeem_amount) +
                  Number(b.loyalty_redeem_amount)
                  : Number(a.loyalty_redeem_amount),
                loyalty_redeem_count: b.loyalty_redeem_count
                  ? Number(a.loyalty_redeem_count) +
                  Number(b.loyalty_redeem_count)
                  : Number(a.loyalty_redeem_count),
                raw_bet: b.raw_bet != null ? Number(a.raw_bet) + Number(b.raw_bet) : Number(a.raw_bet),
                raw_settle: b.raw_settle != null ? Number(a.raw_settle) + Number(b.raw_settle) : Number(a.raw_settle),
                cancel_amount: b.cancel_amount != null ? Number(a.cancel_amount) + Number(b.cancel_amount) : Number(a.cancel_amount),
                cancel_count: b.cancel_count != null ? Number(a.cancel_count) + Number(b.cancel_count) : Number(a.cancel_count),
                withdraw_fee_amount: b.withdraw_fee_amount != null ? Number(a.withdraw_fee_amount) + Number(b.withdraw_fee_amount) : Number(a.withdraw_fee_amount),
              };
            });
          })
          .catch((err) => {
            console.log(err);
            isLoaded.value = true;
          });
      }
    };

    const doSort = (attName) => {
      if (sortBy.value[0] && sortBy.value[0][0] == attName) {
        sortBy.value[0][1] = sortBy.value[0][1] * -1;
      } else {
        sortBy.value = [[attName, -1]];
      }

      let attr_float_name = [
        "deposit",
        "withdraw",
        "depositPlayer",
        "withdrawPlayer",
        "creditAdjustAmount",
        "totalBet",
        "betAmount",
        "validBetAmount",
        "winLoss",
      ];
      dataRows.value = dataRows.value.sort((a, b) => {
        let fa = a[attName],
          fb = b[attName];

        if (attr_float_name.includes(attName)) {
          fa = parseFloat(fa);
          fb = parseFloat(fb);
        }

        if (sortBy.value[0][1] == -1) {
          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
        } else {
          if (fa > fb) {
            return -1;
          }
          if (fa < fb) {
            return 1;
          }
        }

        return 0;
      });

      isLoaded.value = true;
    };

    const exports = () => {
      let fromParams, toParams
      if (fromDate.value || toDate.value) {
        fromParams = fromDate.value
          ? dayjs(fromDate.value).format()
          : dayjs(selected.value.value).startOf("month").format();
        toParams = toDate.value
          ? dayjs(toDate.value).endOf('day').format()
          : dayjs().endOf('day').format();
      } else if (selected.value.label == "Yesterday") {
        fromParams = dayjs(selected.value.value)
          .hour(0)
          .minute(0)
          .second(0)
          .format();
        toParams = dayjs(selected.value.value)
          .hour(23)
          .minute(59)
          .second(59)
          .format();
      } else {
        fromParams = fromDate.value
          ? dayjs(fromDate.value).format()
          : dayjs(selected.value.value).startOf("month").format();
        toParams = toDate.value
          ? dayjs(toDate.value).endOf('day').format()
          : dayjs(selected.value.value).endOf("month").endOf('day').format();
      }
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/report/export/daily-summary-op",
          null,
          {
            params: {
              operatorId: store.state.selectedOperator.operatorId,
              from: fromParams,
              to: toParams,
            },
          }
        )
        .then(({ data }) => {
          window.open(data.result);
        });
    };

    return {
      dataRows,
      dataCount,
      totals,
      isLoaded,
      dayjs,
      selected,
      toDate,
      route,
      prev,
      next,
      search,
      viewData,
      months,
      pages,
      searchRage,
      fromDate,
      doSort,
      exports,
    };
  },
};
</script>
